import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import Color from '../Color.js';
var sqrt = Math.sqrt,
  pow = Math.pow;
import index from './index.js';
var lrgb = function lrgb(col1, col2, f) {
  var _col1$_rgb = _slicedToArray(col1._rgb, 3),
    x1 = _col1$_rgb[0],
    y1 = _col1$_rgb[1],
    z1 = _col1$_rgb[2];
  var _col2$_rgb = _slicedToArray(col2._rgb, 3),
    x2 = _col2$_rgb[0],
    y2 = _col2$_rgb[1],
    z2 = _col2$_rgb[2];
  return new Color(sqrt(pow(x1, 2) * (1 - f) + pow(x2, 2) * f), sqrt(pow(y1, 2) * (1 - f) + pow(y2, 2) * f), sqrt(pow(z1, 2) * (1 - f) + pow(z2, 2) * f), 'rgb');
};

// register interpolator
index.lrgb = lrgb;
export default lrgb;